import * as constants from './constants';

export const setCurDistributionCalculate = (payload) => ({
    type: constants.setCurDistributionCalculate,
    payload
});